import { Avatar, Box, Dialog, DialogContent, DialogTitle, IconButton, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, styled } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
  }));

const ModalXenplatform = ({dialog, handleDialog, handlePayment}) => {

    return (
        <BootstrapDialog
            fullWidth
            maxWidth={"xs"}
            aria-labelledby="customized-dialog-title"
            open={dialog}
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                Xendit - Payment Channel
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={() => handleDialog(false)}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent dividers>
                <Box sx={{ width: '100%'}}>
                    <List dense sx={{ width: '100%', bgcolor: 'background.paper' }}>
                        <ListItem
                            secondaryAction={
                                <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(1)}>
                                    <KeyboardArrowRightIcon />
                                </IconButton>
                            }
                            disablePadding
                        >
                            <ListItemButton
                                onClick={() => handlePayment(1)}
                            >
                                <ListItemAvatar>
                                    <Avatar
                                        variant="square"
                                        alt={`Mandiri`}
                                        src={process.env.PUBLIC_URL + '/bank/Mandiri.png'}
                                    />
                                </ListItemAvatar>
                                <ListItemText primary="Mandiri Virtual Account" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem
                            secondaryAction={
                                <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(2)}>
                                    <KeyboardArrowRightIcon />
                                </IconButton>
                            }
                            disablePadding
                        >
                            <ListItemButton
                                onClick={() => handlePayment(2)}
                            >
                                <ListItemAvatar>
                                    <Avatar
                                        variant="square"
                                        alt={`BRI`}
                                        src={process.env.PUBLIC_URL + '/bank/BRI.png'}
                                    />
                                </ListItemAvatar>
                                <ListItemText primary="BRI Virtual Account" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem
                            secondaryAction={
                                <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(3)}>
                                    <KeyboardArrowRightIcon />
                                </IconButton>
                            }
                            disablePadding
                        >
                            <ListItemButton
                                onClick={() => handlePayment(3)}
                            >
                                <ListItemAvatar>
                                    <Avatar
                                        variant="square"
                                        alt={`BNI`}
                                        src={process.env.PUBLIC_URL + '/bank/BNI.png'}
                                    />
                                </ListItemAvatar>
                                <ListItemText primary="BNI Virtual Account" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem
                            secondaryAction={
                                <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(4)}>
                                    <KeyboardArrowRightIcon />
                                </IconButton>
                            }
                            disablePadding
                        >
                            <ListItemButton
                                onClick={() => handlePayment(4)}
                            >
                                <ListItemAvatar>
                                    <Avatar
                                        variant="square"
                                        alt={`BNI`}
                                        src={process.env.PUBLIC_URL + '/bank/BSI.png'}
                                    />
                                </ListItemAvatar>
                                <ListItemText primary="BSI Virtual Account" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem
                            secondaryAction={
                                <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(5)}>
                                    <KeyboardArrowRightIcon />
                                </IconButton>
                            }
                            disablePadding
                        >
                            <ListItemButton
                                onClick={() => handlePayment(5)}
                            >
                                <ListItemAvatar>
                                    <Avatar
                                        variant="square"
                                        alt={`BJB`}
                                        src={process.env.PUBLIC_URL + '/bank/BJB.png'}
                                    />
                                </ListItemAvatar>
                                <ListItemText primary="BJB Virtual Account" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem
                            secondaryAction={
                                <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(6)}>
                                    <KeyboardArrowRightIcon />
                                </IconButton>
                            }
                            disablePadding
                        >
                            <ListItemButton
                                onClick={() => handlePayment(6)}
                            >
                                <ListItemAvatar>
                                    <Avatar
                                        variant="square"
                                        alt={`CIMB`}
                                        src={process.env.PUBLIC_URL + '/bank/CIMB.png'}
                                    />
                                </ListItemAvatar>
                                <ListItemText primary="CIMB Virtual Account" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem
                            secondaryAction={
                                <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(7)}>
                                    <KeyboardArrowRightIcon />
                                </IconButton>
                            }
                            disablePadding
                        >
                            <ListItemButton
                                onClick={() => handlePayment(7)}
                            >
                                <ListItemAvatar>
                                    <Avatar
                                        variant="square"
                                        alt={`PERMATA`}
                                        src={process.env.PUBLIC_URL + '/bank/Permata.png'}
                                    />
                                </ListItemAvatar>
                                <ListItemText primary="Permata Virtual Account" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem
                            secondaryAction={
                                <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(15)}>
                                    <KeyboardArrowRightIcon />
                                </IconButton>
                            }
                            disablePadding
                        >
                            <ListItemButton
                                onClick={() => handlePayment(15)}
                            >
                                <ListItemAvatar>
                                    <Avatar
                                        variant="square"
                                        alt={`BRILINK`}
                                        src={process.env.PUBLIC_URL + '/bank/BRILINK.png'}
                                    />
                                </ListItemAvatar>
                                <ListItemText primary="BRILink" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem
                            secondaryAction={
                                <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(9)}>
                                    <KeyboardArrowRightIcon />
                                </IconButton>
                            }
                            disablePadding
                        >
                            <ListItemButton
                                onClick={() => handlePayment(9)}
                            >
                                <ListItemAvatar>
                                    <Avatar
                                        variant="square"
                                        alt={`QRIS`}
                                        src={process.env.PUBLIC_URL + '/bank/QRIS.png'}
                                    />
                                </ListItemAvatar>
                                <ListItemText primary="QRIS" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem
                            secondaryAction={
                                <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(10)}>
                                    <KeyboardArrowRightIcon />
                                </IconButton>
                            }
                            disablePadding
                        >
                            <ListItemButton
                                onClick={() => handlePayment(10)}
                            >
                                <ListItemAvatar>
                                    <Avatar
                                        variant="square"
                                        alt={`QRIS`}
                                        src={process.env.PUBLIC_URL + '/bank/Alfamart.png'}
                                    />
                                </ListItemAvatar>
                                <ListItemText primary="Alfamart / Alfamidi" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem
                            secondaryAction={
                                <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(16)}>
                                    <KeyboardArrowRightIcon />
                                </IconButton>
                            }
                            disablePadding
                        >
                            <ListItemButton
                                onClick={() => handlePayment(16)}
                            >
                                <ListItemAvatar>
                                    <Avatar
                                        variant="square"
                                        alt={`Indomaret`}
                                        src={process.env.PUBLIC_URL + '/bank/Indomaret.png'}
                                    />
                                </ListItemAvatar>
                                <ListItemText primary="Indomaret" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem
                            secondaryAction={
                                <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(17)}>
                                    <KeyboardArrowRightIcon />
                                </IconButton>
                            }
                            disablePadding
                        >
                            <ListItemButton
                                onClick={() => handlePayment(17)}
                            >
                                <ListItemAvatar>
                                    <Avatar
                                        variant="square"
                                        alt={`Gopay`}
                                        src={process.env.PUBLIC_URL + '/bank/Gopay.png'}
                                    />
                                </ListItemAvatar>
                                <ListItemText primary="Gopay" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem
                            secondaryAction={
                                <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(11)}>
                                    <KeyboardArrowRightIcon />
                                </IconButton>
                            }
                            disablePadding
                        >
                            <ListItemButton
                                onClick={() => handlePayment(11)}
                            >
                                <ListItemAvatar>
                                    <Avatar
                                        variant="square"
                                        alt={`DANA`}
                                        src={process.env.PUBLIC_URL + '/bank/DANA.png'}
                                    />
                                </ListItemAvatar>
                                <ListItemText primary="Dana" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem
                            secondaryAction={
                                <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(12)}>
                                    <KeyboardArrowRightIcon />
                                </IconButton>
                            }
                            disablePadding
                        >
                            <ListItemButton
                                onClick={() => handlePayment(12)}
                            >
                                <ListItemAvatar>
                                    <Avatar
                                        variant="square"
                                        alt={`OVO`}
                                        src={process.env.PUBLIC_URL + '/bank/OVO.png'}
                                    />
                                </ListItemAvatar>
                                <ListItemText primary="OVO" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem
                            secondaryAction={
                                <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(13)}>
                                    <KeyboardArrowRightIcon />
                                </IconButton>
                            }
                            disablePadding
                        >
                            <ListItemButton
                                onClick={() => handlePayment(13)}
                            >
                                <ListItemAvatar>
                                    <Avatar
                                        variant="square"
                                        alt={`SHOPEE`}
                                        src={process.env.PUBLIC_URL + '/bank/Shopee.png'}
                                    />
                                </ListItemAvatar>
                                <ListItemText primary="ShopeePay" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem
                            secondaryAction={
                                <IconButton edge="end" aria-label="delete" onClick={() => handlePayment(14)}>
                                    <KeyboardArrowRightIcon />
                                </IconButton>
                            }
                            disablePadding
                        >
                            <ListItemButton
                                onClick={() => handlePayment(14)}
                            >
                                <ListItemAvatar>
                                    <Avatar
                                        variant="square"
                                        alt={`LINKAJA`}
                                        src={process.env.PUBLIC_URL + '/bank/LinkAja.png'}
                                    />
                                </ListItemAvatar>
                                <ListItemText primary="LinkAja" />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Box>
            </DialogContent>
        </BootstrapDialog>
    )
}

export default ModalXenplatform;